<template>
  <div class="teacher-container">
    <div class="tab">
      <breadcrumb :list="breadList"></breadcrumb>
      <p class="tab-item">名师风采</p>
    </div>
    <div class="teacher-info">
      <div class="title-box">
        <p class="title">名师风采</p>
      </div>
      <div class="teacher-box">
        <div
          class="teacher-item"
          v-for="item in teacherList"
          :key="item.id"
          @mouseenter="handleShowInfo(item)"
          @mouseleave="handleHideInfo(item)"
          @click="toInfo(item)">
          <img :src="item.teacherPropagateUrl" alt="">
          <div v-show="showInfo && showId === item.id" class="text-box">
            <p class="name">{{ item.teacherName }}</p>
            <p class="desc" v-html="item.teacherIntroduce"></p>
          </div>
          <div class="info" v-show="!item.showInfo">
            <p>{{ item.teacherName }}</p>
          </div>
        </div>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.current"
        :page-sizes="[9, 20, 30, 40]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb'
import { getTeacherList } from '@/api/teacherList'
export default {
  name: 'TeacherList',
  components: {
    Breadcrumb
  },
  data() {
    return {
      teacherList: [],
      showInfo: false,
      showId: '',
      breadList: [
        { label: '名师风采', path: '/teacherList' }
      ],
      pageInfo: {
        pageSize: 9,
        total: 0,
        current: 1
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    handleSizeChange(val) {
      this.pageInfo.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageInfo.current = val
      this.getList()
    },
    toInfo(data) {
      this.$router.push({
        path: '/teacherIntroduce',
        query: {
          id: data.id
        }
      })
    },
    handleHideInfo(info) {
      info.showInfo = false
      this.showInfo = false
      this.showId = ''
    },
    handleShowInfo(info) {
      info.showInfo = true
      this.showInfo = true
      this.showId = info.id
    },
    getList() {
      getTeacherList({
        page: this.pageInfo.current,
        limit: this.pageInfo.pageSize
      }).then(res => {
        const { code, data } = res
        if (code === 0) {
          this.teacherList = data.records
          this.pageInfo = {
            pageSize: Number(data.size),
            total: Number(data.total),
            current: Number(data.current)
          }
        }
        console.log('11', code, data)
      })
    }
  }
}
</script>

<style lang="scss">
.teacher-container {
  width: 1300px;
  margin: 26px auto 0;
  padding: 29px 30px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  box-sizing: border-box;
  .tab {
    width: 280px;
    display: flex;
    flex-direction: column;
    .breadcrumb {
      width: 100%;
    }
    .tab-item {
      width: 100%;
      height: 70px;
      line-height: 70px;
      font-weight: bold;
      display: flex;
      align-items: center;
      font-size: 20px;
      color: #fff;
      background-image: url('../../assets/image/tab-bg2.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      padding: 0 30px;
      box-sizing: border-box;
      &::before {
        content: '';
        display: inline-block;
        width: 9px;
        height: 9px;
        border-radius: 50%;
        margin-right: 8px;
        background-color: #FF4E4E;
        line-height: 70px;
      }
    }
  }
  .teacher-info {
    width: 870px;
    background-color: #fff;
    box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.08);
    padding: 20px 40px;
    box-sizing: border-box;
    margin-left: 30px;
    .title-box {
      border-bottom: 2px solid rgba(8, 93, 200, .3);
    }
    .title {
      width: 95px;
      font-size: 20px;
      font-weight: bold;
      color: #0866CD;
      padding-bottom: 10px;
      box-sizing: border-box;
      position: relative;
      text-align: center;
      &::before {
        content: '';
        display: inline-block;
        width: 95px;
        height: 4px;
        background-color: #FF4E4E;
        border-radius: 2px;
        position: absolute;
        bottom: -2px;
        left: 0;
        text-align: center;
      }
    }
    .teacher-box {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .teacher-item {
        width: 250px;
        height: 225px;
        margin-top: 40px;
        position: relative;
        cursor: pointer;
        margin-left: 5px;
        &:nth-child(3n + 1) {
          margin-left: 0;
        }
        img {
          width: 250px;
          height: 190px;
        }
        .info {
          p {
            width: 100%;
            position: absolute;
            bottom: 0;
            height: 35px;
            line-height: 35px;
            text-align: center;
            font-size: 14px;
            font-weight: bold;
            color: #fff;
            background-color: rgba(27, 134, 255, .61);
          }
        }
        .text-box {
          position: absolute;
          top: 0;
          width: 250px;
          height: 100%;
          background-color: rgba(27, 134, 255, .8);
          padding: 26px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: center;
          p {
            color: #fff;
            font-size: 14px;
            line-height: 23px;
            overflow:hidden;
            text-overflow:ellipsis;
            display:-webkit-box;
            -webkit-box-orient:vertical;
            -webkit-line-clamp:5
          }
          .name {
            text-align: center;
            font-weight: bold;
          }
          .desc {
            // height: 41px;
            margin-top: 15px;
            p {
              span {
                color: #fff !important;
              }
              img {
                height: 50px;
              }
            }
          }
        }
      }
    }
  }
  .el-pagination {
    text-align: center;
    margin-top: 50px;
    .el-pagination__total {
      color: #333;
    }
    .el-input__inner, .el-pager li.active {
      color: #333;
      background-color: rgba(10, 101, 219, 0.22);
      border: 1px solid #0753B6;
    }
    .el-pager li.active {
      color: #0753B6;
      border-radius: 5px;
    }
    span {
      color: #333;
    }
  }
}
</style>
